import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      RATE_YOUR_EXPERIENCE: "Hvordan var din opplevelse?",

      WHAT_CAN_WE_DO_BETTER: "Hva kan vi gjøre bedre?",
      WHAT_DID_WE_DO_SO_GOOD: "Hva gjorde vi bra?",

      AWFUL: "Fryktelig",
      BAD: "Dårlig",
      OKAY: "Ok",
      GOOD: "Bra",
      GREAT: "Fantastisk",

      SHOW_MY_MENU: "Vis min meny",
      AND_PICK_YOUR_DISHES: "...og velg dine retter!",
    },

    se: {
      RATE_YOUR_EXPERIENCE: "Betygsätt din upplevelse",

      WHAT_CAN_WE_DO_BETTER: "Vad kan vi göra bättre?",
      WHAT_DID_WE_DO_SO_GOOD: "Vad gjorde vi så bra?",

      AWFUL: "Hemsk",
      BAD: "Dålig",
      OKAY: "Okej",
      GOOD: "Bra",
      GREAT: "Fantastisk",

      SHOW_MY_MENU: "Visa min meny",
      AND_PICK_YOUR_DISHES: "...och välj dina rätter!",
    },

    dk: {
      RATE_YOUR_EXPERIENCE: "Hvordan var din oplevelse?",

      WHAT_CAN_WE_DO_BETTER: "Hvad kan vi gøre bedre?",
      WHAT_DID_WE_DO_SO_GOOD: "Hvad gjorde vi godt?",

      AWFUL: "Meget dårlig",
      BAD: "Dårlig",
      OKAY: "Ok",
      GOOD: "God",
      GREAT: "Fantastisk",

      SHOW_MY_MENU: "Vis min menu",
      AND_PICK_YOUR_DISHES: "...og vælg retter nu",
    },
  } as const
)[language];
